import { GenericLazyString, gettext } from '@eventbrite/i18n';
import React from 'react';
import styles from './HeroCard.module.scss';
import BottomBlobSvg from './__fixtures__/bottomBlob';
import TopBlobSvg from './__fixtures__/topBlob';

interface HeroCardProps {
    title: string | GenericLazyString;
}

export const HeroCard: React.FC<HeroCardProps> = ({ title }) => {
    return (
        <div data-heap-id={`POI-HeroCard-${title}`} className={styles.root}>
            <div className={styles.topBlob}>
                <TopBlobSvg />
            </div>
            <div className={styles.bottomBlob}>
                <BottomBlobSvg />
            </div>
            <div className={styles.textItems}>
                <h1>
                    <span className={styles.orangeText}>
                        {gettext('EVENTS AND THINGS TO DO NEAR')}
                    </span>
                    <br />
                    <span className={styles.greenText}>
                        {title.toLocaleUpperCase()}
                    </span>
                </h1>
            </div>
        </div>
    );
};
